"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = install;
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.object.keys");
require("core-js/modules/web.dom.iterable");
var _vue = _interopRequireDefault(require("vue"));
var _titleContent = _interopRequireDefault(require("./left/titleContent.vue"));
var _imgBottom = _interopRequireDefault(require("./left/imgBottom.vue"));
var _index = _interopRequireDefault(require("./left/graphicnavigation/index.vue"));
var _index2 = _interopRequireDefault(require("./left/search/index.vue"));
var _index3 = _interopRequireDefault(require("./left/borderLine/index.vue"));
var _index4 = _interopRequireDefault(require("./left/notice/index.vue"));
var _index5 = _interopRequireDefault(require("./left/elevatorNavigation/index.vue"));
var _index6 = _interopRequireDefault(require("./left/hotspotCutout/index.vue"));
var _videoComponent = _interopRequireDefault(require("./left/videoComponent.vue"));
var _floatingButton = _interopRequireDefault(require("./left/floatingButton.vue"));
var _index7 = _interopRequireDefault(require("./placementarea/index.vue"));
var _index8 = _interopRequireDefault(require("./right/decorate/index.vue"));
var _index9 = _interopRequireDefault(require("./right/componenmanagement/index.vue"));
var _index0 = _interopRequireDefault(require("./right/contentsstyle/index.vue"));
var _index1 = _interopRequireDefault(require("./right/imgStyle/index.vue"));
var _index10 = _interopRequireDefault(require("./right/graphicnavigationstyle/index.vue"));
var _index11 = _interopRequireDefault(require("./right/searchstyle/index.vue"));
var _index12 = _interopRequireDefault(require("./right/borderLineStyle/index.vue"));
var _index13 = _interopRequireDefault(require("./right/noticestyle/index.vue"));
var _index14 = _interopRequireDefault(require("./right/elevatorNavigationStyle/index.vue"));
var _index15 = _interopRequireDefault(require("./right/hotspotCoutoutStyle/index.vue"));
var _index16 = _interopRequireDefault(require("./right/videoStyle/index.vue"));
var _index17 = _interopRequireDefault(require("./right/floatingButtonStyle/index.vue"));
/**
 * 自定义页面（拖拉装修）- 动态组件全局注册入口
 *
 * 装修页 configPage.vue 通过 <component :is="item.component"> / <component :is="rightcom">
 * 按字符串名称渲染组件，这些组件必须在 Vue 上全局注册过才能解析成功。
 *
 * 这里集中维护所有"按名称渲染"的组件，并在 main.js 中调用 install。
 * 直接在 .vue 中 import 的组件（如 leftConfigPage / headTop / phoneBottom）不需要在此注册。
 */

/* 中间手机区渲染的业务组件（对应 componentProperties 的 component 字段） */

/* 右侧属性面板（对应 componentProperties 的 style 字段，以及 decorate / componenmanagement） */

var components = {
  titleContent: _titleContent.default,
  imgBottom: _imgBottom.default,
  graphicnavigation: _index.default,
  search: _index2.default,
  borderLine: _index3.default,
  notice: _index4.default,
  elevatorNavigation: _index5.default,
  hotspotCutout: _index6.default,
  videoComponent: _videoComponent.default,
  floatingButton: _floatingButton.default,
  placementarea: _index7.default,
  decorate: _index8.default,
  componenmanagement: _index9.default,
  contentsstyle: _index0.default,
  imgStyle: _index1.default,
  graphicnavigationstyle: _index10.default,
  searchstyle: _index11.default,
  borderLineStyle: _index12.default,
  noticestyle: _index13.default,
  elevatorNavigationStyle: _index14.default,
  hotspotCoutoutStyle: _index15.default,
  videoStyle: _index16.default,
  floatingButtonStyle: _index17.default
};
function install() {
  Object.keys(components).forEach(function (name) {
    // 防止重复注册（开发环境 HMR 会出现）
    if (_vue.default.options.components[name]) return;
    _vue.default.component(name, components[name]);
  });
}